import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import axiosWrapper from "../services/axiosWrapper";
import { QueryBuilder, executeQuery } from "../services/queryBuilder";
import { includedProjectsUrl } from "../services/dataManager";
import { setProjectData, setSpaceData } from "../reducers/breadcrumbsdata";
import type { GetSpaceByIdRequest, GetSpaceByIdResponse, SpaceDataItem } from "@ServerTypes/spaces/space.schema";
import type { GetProjectByIdRequest } from "@ServerTypes/projects/project.schema";
import type { Exact } from "@Helpers/types/exact";

export function getCurrProjectData<T extends Exact<GetProjectByIdRequest, T>>(data: T) {
  return async (dispatch: AppDispatch) => {
    const query = new QueryBuilder().where("_id", "equal", data.id);
    if (data.originSource) {
      query.addParams("originSource", data.originSource);
    }
    const queryResult = await executeQuery(includedProjectsUrl, query);
    const response: any = queryResult.result[0];

    if (response?.image != "") {
      dispatch(
        setProjectData({
          ...response,
          projectImageUrl: getUrlForImage({ id: data.id }, "projectImage"),
        }),
      );
    } else {
      dispatch(setProjectData({ ...response }));
    }
  };
}

export function getCurrSpaceData<T extends Exact<GetSpaceByIdRequest, T>>(data: T) {
  return (dispatch: AppDispatch) => {
    axiosWrapper
      .post<GetSpaceByIdResponse>(`${getBackendUrl()}/spaces/getSpaceById`, data)
      .then((res) => {
        return res.data;
      })
      .then((res) => dispatch(setSpaceData((res.data ?? []) as SpaceDataItem[])))
      .catch((error) => {
        Promise.reject(error);
      });
  };
}

export function getSpaceDataBySpaceId<T extends Exact<GetSpaceByIdRequest, T>>(data: T) {
  return async (dispatch: AppDispatch) => {
    axiosWrapper
      .post<GetSpaceByIdResponse>(`${getBackendUrl()}/spaces/getSpaceById`, data)
      .then((res) => {
        dispatch(setSpaceData((res.data.data ?? []) as SpaceDataItem[]));
      })
      .catch((err: unknown) => {
        console.log("ERROR IN GETSPACEDATABYSPACEID ", err);
        Promise.reject(err);
      });
  };
}
